module.exports = __webpack_public_path__ + "img/zuijia_18.6fd101f4.png";